import { render } from "./ClaimSuccess.vue?vue&type=template&id=50e9c1d3"
import script from "./ClaimSuccess.vue?vue&type=script&lang=js"
export * from "./ClaimSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__